var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSplashNwn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 740 680",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Scene-Home",
    serifId: "Scene/Home",
    transform: "matrix(1.07091,0,0,1.07091,-17.1346,13.3719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clock",
    transform: "matrix(1,0,0,1,559.85,46.2006)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Clock-Frame",
    cx: 53,
    cy: 53,
    r: 53,
    style: {
      fill: "rgb(159,175,202)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Time",
    cx: 53,
    cy: 11,
    r: 3,
    style: {
      fill: "white",
      fillOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Time1",
    serifId: "Time",
    cx: 11,
    cy: 53,
    r: 3,
    style: {
      fill: "white",
      fillOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Time2",
    serifId: "Time",
    cx: 95,
    cy: 53,
    r: 3,
    style: {
      fill: "white",
      fillOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Time3",
    serifId: "Time",
    cx: 53,
    cy: 95,
    r: 3,
    style: {
      fill: "white",
      fillOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Hand",
    d: "M53,17L55,52L51,52L53,17Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hand1",
    serifId: "Hand",
    transform: "matrix(-0.707107,0.707107,-0.707107,-0.707107,150.196,62.2132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.213,50.213L64.213,74.213L60.213,74.213L62.213,50.213Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Time4",
    serifId: "Time",
    cx: 53,
    cy: 53,
    r: 4,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background-Shape-2",
    transform: "matrix(1,0,0,1,29,244)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background-Shape",
    transform: "matrix(-1,0,0,1,473,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.206,172.385C7.101,95.336 377.036,-53.376 445.713,19.603C514.39,92.582 448.365,229.545 304.444,264.617C160.522,299.69 -6.688,249.434 0.206,172.385Z",
    style: {
      fill: "rgb(14,56,122)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Background-Shape1",
    serifId: "Background-Shape",
    d: "M244.144,222.448C250.32,156.992 581.692,30.655 643.21,92.654C704.728,154.652 689.157,285.059 560.238,314.854C431.319,344.65 237.968,287.904 244.144,222.448Z",
    style: {
      fill: "rgb(14,56,122)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Hanging-Lamp",
    transform: "matrix(1,0,0,1,25,-15.8743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Light",
    transform: "matrix(1,0,0,1,0,152.673)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Hanging-Lamp-Light",
    cx: 49.5,
    cy: 34.5,
    rx: 42.5,
    ry: 22.5,
    style: {
      fill: "rgb(242,242,242)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Hanging-Lamp1",
    serifId: "Hanging-Lamp",
    d: "M99,50C99,22.386 76.838,0 49.5,0C22.162,0 -0,22.386 -0,50",
    style: {
      fill: "rgb(221,227,233)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Wire",
    x: 47,
    y: 0,
    width: 5,
    height: 160,
    style: {
      fill: "rgb(221,227,233)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hanging-Lamp2",
    serifId: "Hanging-Lamp",
    transform: "matrix(1,0,0,1,115,-15.8743)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Light1",
    serifId: "Light",
    transform: "matrix(1,0,0,1,0,113)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Hanging-Lamp-Light1",
    serifId: "Hanging-Lamp-Light",
    cx: 37,
    cy: 27.842,
    rx: 31.768,
    ry: 18.158,
    style: {
      fill: "rgb(242,242,242)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Hanging-Lamp3",
    serifId: "Hanging-Lamp",
    d: "M74,40.351C74,18.066 57.435,0 37,0C16.565,0 -0,18.066 -0,40.351",
    style: {
      fill: "rgb(221,227,233)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Wire1",
    serifId: "Wire",
    x: 35,
    y: 0,
    width: 5,
    height: 136,
    style: {
      fill: "rgb(221,227,233)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Lamp",
    transform: "matrix(1,0,0,1,524,223.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Body",
    d: "M60,36.236L78.568,17.656C81.691,14.531 86.757,14.53 89.881,17.653C89.882,17.654 89.883,17.655 89.884,17.656L139.316,67.113C142.315,70.114 144,74.182 144,78.424L144,406",
    style: {
      fill: "none",
      stroke: "rgb(203,203,203)",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lamp-Top",
    transform: "matrix(0.707107,0.707107,-0.707107,0.707107,48.7904,1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Lamp1",
    serifId: "Lamp",
    d: "M33.03,1.384C51.256,1.384 66.03,16.159 66.03,34.384L66.03,62.384L0.03,62.384L0.03,34.384C0.03,16.159 14.805,1.384 33.03,1.384Z",
    style: {
      fill: "rgb(197,207,214)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Lamp2",
    serifId: "Lamp",
    cx: 33.209,
    cy: 61.445,
    rx: 33,
    ry: 6.5,
    style: {
      fill: "rgb(242,242,242)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Big-Leaf-Plant",
    transform: "matrix(1,0,0,1,16,397.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Big-Ass-Leaf",
    transform: "matrix(1,0,0,1,22,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "leaf",
    d: "M25.258,1.173C28.123,0.823 31.18,0.947 33.844,2.077C39.509,4.482 41.119,11.174 41.041,16.614C40.957,22.468 39.714,28.863 44.165,33.58C46.211,35.748 48.756,37.408 50.765,39.617C52.912,41.977 54.597,44.677 55.844,47.577C58.134,52.903 59.258,59.167 57.164,64.754C55.32,69.674 50.681,74.114 51.683,79.708C52.729,85.543 58.612,90.004 62.29,94.351C66.453,99.269 70.286,105.556 70.916,112.006C71.519,118.188 68.828,124.44 64.699,129.113C56.448,138.451 44.045,143.028 31.54,143C26.23,142.988 20.219,142.748 15.637,139.895C14.22,139.013 13.473,138.023 12.631,136.648C11.877,135.414 10.88,134.612 9.725,133.739C7.19,131.822 5.359,129.239 4.19,126.347C-0.348,115.114 3.279,101.218 9.631,91.243C11.136,88.88 12.369,86.605 11.637,83.789C10.874,80.848 8.999,78.196 7.34,75.669C5.701,73.17 3.83,70.787 2.549,68.087C1.207,65.257 0.829,62.294 1.066,59.198C1.512,53.381 4.023,48.013 7.578,43.336C11.002,38.83 15.022,34.518 15.031,28.615C15.041,22.357 10.858,16.791 12.64,10.429C13.378,7.795 14.86,5.092 17.249,3.513C19.539,1.998 22.564,1.502 25.258,1.173Z",
    style: {
      fill: "rgb(105,161,172)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "middle-thing",
    d: "M23.386,11.176C23.44,10.336 24.437,9.832 25.222,10.051C26.254,10.34 26.235,11.305 26.207,12.165C26.124,14.808 26.506,17.377 27.142,19.942C28.462,25.274 30.903,30.186 32.836,35.308C34.768,40.425 35.675,45.709 34.542,51.124C33.473,56.23 31.795,61.203 30.701,66.315C29.738,70.821 28.712,75.573 30.18,80.067C31.592,84.393 34.714,87.916 36.962,91.825C41.617,99.918 43.681,108.896 43.957,118.135C44.085,122.425 43.97,126.755 42.975,130.963C42.402,133.386 41.632,136.66 39.556,138.333C38.599,139.105 36.961,139.371 36.155,138.229C35.399,137.158 36.062,135.499 36.303,134.357C37.343,129.413 37.552,124.361 37.303,119.342C37.062,114.48 36.487,109.626 34.957,104.982C33.537,100.673 31.379,96.802 28.84,93.032C26.252,89.191 23.562,85.341 22.493,80.789C21.406,76.166 22.289,71.462 23.469,66.927C24.717,62.131 26.352,57.472 28.042,52.805C29.689,48.258 30.272,43.955 29.363,39.196C27.567,29.794 22.76,20.968 23.386,11.176Z",
    style: {
      fill: "rgb(193,222,226)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Big-Ass-Leaf1",
    serifId: "Big-Ass-Leaf",
    transform: "matrix(1,0,0,1,32,11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "leaf1",
    serifId: "leaf",
    d: "M90.892,1.582C94.437,2.659 97.958,4.395 100.485,7.118C105.858,12.909 104.209,21.661 101.243,28.053C98.05,34.933 93.212,41.849 95.94,49.743C97.193,53.372 99.301,56.659 100.49,60.316C101.761,64.224 102.309,68.294 102.239,72.372C102.11,79.862 100.118,87.855 94.708,93.373C89.945,98.232 82.158,101.07 80.377,108.206C78.518,115.651 83.061,123.988 85.078,131.041C87.36,139.024 88.533,148.453 85.862,156.409C83.303,164.034 76.842,170.028 69.528,173.406C54.915,180.156 37.949,179.117 23.296,172.578C17.075,169.801 10.151,166.391 6.285,160.633C5.09,158.853 4.736,157.294 4.476,155.23C4.243,153.378 3.497,151.911 2.605,150.278C0.644,146.692 -0.138,142.684 0.02,138.656C0.634,123.011 12.234,108.464 24.956,99.972C27.971,97.96 30.618,95.912 31.249,92.2C31.909,88.325 31.111,84.213 30.501,80.361C29.899,76.554 28.964,72.763 28.889,68.902C28.811,64.858 29.933,61.157 31.848,57.619C35.445,50.972 41.227,45.93 47.87,42.247C54.267,38.7 61.262,35.692 64.393,28.715C67.712,21.32 65.747,12.561 71.2,5.964C73.458,3.233 76.625,0.807 80.262,0.182C83.749,-0.417 87.558,0.57 90.892,1.582Z",
    style: {
      fill: "rgb(137,197,204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "middle-thing1",
    serifId: "middle-thing",
    d: "M83.651,13.811C84.154,12.844 85.584,12.769 86.387,13.44C87.443,14.324 86.914,15.456 86.432,16.46C84.95,19.547 84.052,22.789 83.452,26.159C82.204,33.166 82.485,40.262 82.063,47.341C81.642,54.414 79.935,61.147 75.774,66.965C71.85,72.452 67.283,77.462 63.327,82.943C59.841,87.773 56.153,92.863 55.516,98.954C54.901,104.817 56.707,110.626 57.288,116.434C58.492,128.457 56.204,140.171 51.688,151.257C49.591,156.405 47.189,161.472 43.821,165.933C41.882,168.502 39.267,171.977 35.963,172.869C34.44,173.281 32.385,172.739 32.042,170.964C31.718,169.298 33.363,167.682 34.242,166.455C38.047,161.146 40.938,155.273 43.275,149.198C45.54,143.314 47.41,137.265 48.053,130.963C48.649,125.116 48.153,119.401 47.158,113.606C46.144,107.701 45.015,101.731 46.149,95.781C47.3,89.736 50.795,84.628 54.55,79.876C58.521,74.85 62.873,70.19 67.293,65.549C71.6,61.027 74.536,56.238 75.966,50.126C78.79,38.049 77.791,25.078 83.651,13.811Z",
    style: {
      fill: "rgb(193,222,226)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Big-Ass-Leaf2",
    serifId: "Big-Ass-Leaf",
    transform: "matrix(1,0,0,1,0,57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "leaf2",
    serifId: "leaf",
    d: "M13.306,-0C19.2,-0 24.382,3.124 27.953,7.558C32.133,12.748 32.977,19.086 34.675,25.272C35.519,28.35 36.972,31.406 39.517,33.498C41.833,35.4 44.772,35.78 47.544,36.71C53.082,38.567 57.555,43.041 59.321,48.499C61.476,55.158 59.193,61.873 59.586,68.622C59.947,74.819 66.058,78.685 70.974,81.656C75.821,84.586 80.189,87.328 81.649,93.035C83.197,99.088 83.716,105.844 81.572,111.823C78.002,121.779 67.552,126.163 57.456,126.842C48.293,127.459 36.772,126.491 29.891,119.84C25.773,115.86 24.282,110.293 24.467,104.755C24.582,101.311 25.264,97.899 26.146,94.571C26.771,92.213 27.616,89.864 27.856,87.427C28.496,80.942 22.503,79.697 17.401,77.916C10.918,75.654 6.38,71.38 3.224,65.425C0.285,59.881 -0.948,53.658 0.814,47.554C1.714,44.437 3.346,41.61 5.559,39.205C6.533,38.146 7.907,37.263 8.786,36.151C9.607,35.112 9.428,33.766 9.145,32.55C7.837,26.931 3.762,22.278 2.305,16.668C0.989,11.605 1.767,5.304 6.395,2.038C8.395,0.627 10.862,0.016 13.306,-0Z",
    style: {
      fill: "rgb(137,197,204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "middle-thing2",
    serifId: "middle-thing",
    d: "M21.338,14.641C27.585,21.296 29.283,30.325 29.781,39.076C30.061,43.983 29.77,49.159 31.212,53.919C32.445,57.993 35.337,61.107 38.318,64.051C44.319,69.975 51.011,75.999 52.766,84.574C53.796,89.606 53.101,94.804 54.524,99.78C55.817,104.304 58.096,108.748 60.867,112.568C63.098,115.645 66.004,118 68.443,120.867C69.187,121.743 70.253,123.031 69.946,124.267C69.586,125.714 67.743,126.172 66.435,125.945C63.386,125.415 60.819,122.503 58.825,120.386C55.91,117.291 53.432,113.962 51.419,110.227C49.183,106.08 47.383,101.679 46.614,97.026C45.816,92.199 46.213,87.168 44.391,82.535C41.324,74.74 33.886,70.14 28.508,64.064C21.808,56.494 22.807,47.072 23.493,37.759C23.87,32.641 24.245,26.862 21.659,22.189C20.672,20.406 18.471,18.743 18.047,16.715C17.658,14.858 19.78,12.981 21.338,14.641Z",
    style: {
      fill: "rgb(193,222,226)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Base",
    d: "M28,181C28,219.058 34.211,239 67,239C99.789,239 106,219.058 106,181L28,181Z",
    style: {
      fill: "rgb(142,90,41)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "matrix(1,0,0,1,135,367.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lamp3",
    serifId: "Lamp",
    transform: "matrix(1,0,0,1,23,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Lamp-Base",
    d: "M59,145.868C59,144.837 58.163,144 57.132,144L22.868,144C21.837,144 21,144.837 21,145.868L21,151.132C21,152.163 21.837,153 22.868,153L57.132,153C58.163,153 59,152.163 59,151.132L59,145.868Z",
    style: {
      fill: "rgb(175,185,197)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Lamp-Body",
    d: "M31,115C35.293,101.085 37.699,86.419 38.217,71L42.783,71C43.301,86.419 45.707,101.085 50,115L56.5,115C65.06,115 72,121.94 72,130.5C72,139.06 65.06,146 56.5,146L23.5,146C14.94,146 8,139.06 8,130.5C8,121.94 14.94,115 23.5,115L31,115Z",
    style: {
      fill: "rgb(221,227,233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shade",
    d: "M4.622,1.679C16.081,0.56 27.541,0 39,0C50.459,0 61.919,0.56 73.378,1.679L78,81.133C65,82.378 52,83 39,83C26,83 13,82.378 0,81.133L4.622,1.679Z",
    style: {
      fill: "rgb(197,207,214)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,153L125,153L125,257L104,257L104,175L21,175L21,257L0,257L0,153Z",
    style: {
      fill: "rgb(197,207,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "matrix(1,0,0,1,537,353.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Succulents",
    transform: "matrix(1,0,0,1,13,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Thi-Succs-",
    serifId: "Thi-Succs!",
    d: "M3.381,0.208C12.214,21.197 27.229,35.781 35.182,57.605C39.898,70.547 41.864,84.62 41.983,99.032C42.048,106.86 41.911,114.694 41.875,122.522C41.839,130.156 41.632,137.741 40.984,145.327C40.332,152.952 39.603,160.487 39.282,168.159C39.031,174.137 38.917,181.091 36.891,186.544C35.279,190.881 31.183,191.516 30.097,186.256C29.493,183.333 29.569,180.068 29.636,177.063C29.721,173.208 29.945,169.359 30.06,165.504C30.519,150.036 29.923,134.566 30.235,119.092C30.539,103.973 32.482,88.871 30.332,73.853C28.556,61.452 24.046,50.802 18.862,40.593C13.874,30.771 8.445,21.187 5.075,10.014C4.107,6.806 3.359,3.481 3,0.03C3.157,-0.043 3.284,0.016 3.381,0.208Z",
    style: {
      fill: "rgb(193,222,226)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Thi-Succs-1",
    serifId: "Thi-Succs!",
    d: "M0.974,41.617C2.723,42.88 3.7,44.728 4.882,46.551C6.352,48.817 8.081,50.863 9.551,53.131C12.615,57.86 15.308,62.879 18.102,67.799C23.406,77.137 27.433,87.091 29.427,97.895C31.495,109.092 32.052,120.648 32.919,132.012C33.839,144.056 34.765,156.188 34.887,168.279C34.942,173.696 35.235,179.446 34.584,184.825C34.179,188.173 32.668,191.027 29.261,191C22.025,190.942 18.627,182.927 17.208,176.354C15.119,166.674 14.702,156.393 15.033,146.494C15.432,134.558 17.504,122.802 18.4,110.912C19.35,98.325 18.814,85.96 14.486,74.109C12.3,68.12 9.763,62.274 7.484,56.325C6.514,53.792 5.719,51.19 4.409,48.831C2.951,46.208 1.142,43.826 -0,41C0.324,41.206 0.649,41.411 0.974,41.617Z",
    style: {
      fill: "rgb(137,197,204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Thi-Succs-2",
    serifId: "Thi-Succs!",
    d: "M84.334,16.518C84.556,16.345 84.778,16.173 85,16C84.361,18.693 83.207,20.88 82.324,23.341C81.531,25.554 81.129,28.058 80.595,30.477C79.34,36.158 77.89,41.711 76.706,47.44C74.36,58.777 74.804,70.99 76.342,83.568C77.795,95.45 80.092,107.313 81.187,119.192C82.095,129.043 82.485,139.202 81.619,148.601C81.031,154.984 79.103,162.606 73.848,161.962C71.374,161.659 70.084,158.681 69.564,155.32C68.729,149.922 68.554,144.246 68.229,138.878C67.502,126.896 67.358,114.951 67.214,103.092C67.078,91.904 66.705,80.494 67.452,69.587C68.173,59.063 70.428,49.58 73.653,40.83C75.351,36.22 76.97,31.502 78.878,27.108C79.793,25.001 80.911,23.139 81.827,21.033C82.563,19.339 83.148,17.601 84.334,16.518Z",
    style: {
      fill: "rgb(193,222,226)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Thi-Succs-3",
    serifId: "Thi-Succs!",
    d: "M3.209,76.302C4.166,74.695 6.272,79.993 6.593,80.66C6.457,80.328 6.321,79.997 6.184,79.667C8.083,82.825 9.821,86.113 10.901,89.734C11.97,93.319 12.888,96.977 13.891,100.587C15.774,107.361 18.202,113.943 19.907,120.778C21.569,127.438 21.988,133.986 21.585,140.875C21.167,148.035 20.911,155.306 21.399,162.462C21.632,165.88 22.743,169.064 23.504,172.354C24.266,175.648 24.866,178.986 25.767,182.239C25.974,181.815 26,183.232 26,183.339C25.994,184.152 25.881,184.833 25.619,185.604C24.948,187.586 23.691,189.269 21.778,189.816C18.322,190.803 15.112,187.659 13.998,184.339C12.399,179.575 11.517,174.311 10.755,169.304C10.057,164.713 9.891,160.094 10.099,155.44C10.508,146.261 12.169,137.202 12.618,128.026C13.107,118.036 11.128,108.649 9.471,98.925C8.673,94.239 7.91,89.598 6.356,85.134C5.727,83.326 4.907,81.731 4.048,80.061C3.558,79.112 2.569,77.418 3.209,76.302Z",
    style: {
      fill: "rgb(193,222,226)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Thi-Succs-4",
    serifId: "Thi-Succs!",
    d: "M31.252,60.697C30.856,72.142 30.172,83.5 28.646,94.824C27.089,106.38 25.3,117.897 23.802,129.463C22.343,140.722 20.815,152.168 21.018,163.584C21.168,171.993 19.774,186.219 29.113,190.369C38.572,194.572 40.601,176.623 41.222,170.699C42.412,159.333 42.027,147.847 41.449,136.419C40.856,124.689 39.866,113.02 38.64,101.334C37.277,88.353 36.208,75.314 35.349,62.296C34.925,55.857 34.82,49.429 34.937,42.988C35.048,36.911 34.817,30.77 32.656,25C32.543,25.082 32.431,25.164 32.318,25.246",
    style: {
      fill: "rgb(105,161,172)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Thi-Succs-5",
    serifId: "Thi-Succs!",
    d: "M80.083,96.955C78.382,99.433 76.667,101.887 75.061,104.512C72.186,109.209 69.587,114.432 68.805,121.147C67.169,135.2 68.481,150.379 68.798,164.863C68.863,167.822 68.489,170.693 69.655,173.51C70.713,176.064 72.691,178.01 74.576,178C78.611,177.977 77.995,168.095 78.002,163.746C78.014,156.123 77.159,148.422 77.233,140.806C77.306,133.26 77.765,125.694 78.859,118.528C79.967,111.275 81.589,104.309 83.729,97.81C84.026,96.908 86.158,89.937 84.144,91.139",
    style: {
      fill: "rgb(137,197,204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Thi-Succs-6",
    serifId: "Thi-Succs!",
    d: "M62.262,22C59.609,22 59.625,35.226 59.546,36.925C59.257,43.055 59.325,49.188 59.143,55.319C58.744,68.701 58.254,82.2 56.243,95.426C55.161,102.547 53.907,109.636 52.557,116.702C51.204,123.789 49.387,130.867 48.497,138.044C47.642,144.943 48.125,151.977 48.242,158.91C48.359,165.885 48.57,172.874 49.484,179.788C49.709,181.494 49.974,183.195 50.257,184.891C50.492,186.305 50.355,188.058 50.754,189.401C51.393,191.552 54.133,192.256 55.978,191.92C60.97,191.009 64.159,184.74 65.865,180.16C68.043,174.311 69.199,167.967 70.339,161.804C71.631,154.821 72.388,147.732 72.743,140.623C73.466,126.175 72.539,111.712 71.504,97.31C70.928,89.301 70.263,81.327 69.246,73.367C68.232,65.441 66.932,57.55 66.086,49.601C65.471,43.825 64.865,38.04 64.467,32.241C64.371,30.859 64.291,22 62.262,22",
    style: {
      fill: "rgb(105,161,172)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Thi-Succs-7",
    serifId: "Thi-Succs!",
    d: "M58.941,118.139C58.508,104.253 52.927,43.259 51.657,26.467C51.339,22.264 48.282,4.765 47.885,-0C46.81,1.347 46.901,22.309 46.913,27.126C46.926,31.891 46.335,36.576 46.031,41.315C45.721,46.151 38.572,108.601 37.645,113.247C35.799,122.491 34.564,131.976 33.611,141.428C32.683,150.639 31.24,160.358 32.482,169.618C32.767,171.75 33.219,173.848 33.955,175.806C34.749,177.922 35.294,179.879 35.932,182.093C36.958,185.659 38.815,188.789 41.668,190.262C47.517,193.281 50.658,186.447 52.251,180.497C54.793,170.995 56.426,161.338 57.191,151.359C58.037,140.318 59.287,129.255 58.941,118.139",
    style: {
      fill: "rgb(137,197,204)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Planter",
    transform: "matrix(1,0,0,1,0,159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vase",
    d: "M101,1.868C101,0.837 100.163,0 99.132,0L11.868,0C10.837,0 10,0.837 10,1.868L10,89.132C10,90.163 10.837,91 11.868,91L99.132,91C100.163,91 101,90.163 101,89.132L101,1.868Z",
    style: {
      fill: "rgb(142,90,41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg",
    d: "M10,11.868C10,10.837 9.163,10 8.132,10L1.868,10C0.837,10 0,10.837 0,11.868L0,121.132C0,122.163 0.837,123 1.868,123L8.132,123C9.163,123 10,122.163 10,121.132L10,11.868Z",
    style: {
      fill: "rgb(197,207,214)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg1",
    serifId: "Leg",
    d: "M60,11.868C60,10.837 59.163,10 58.132,10L51.868,10C50.837,10 50,10.837 50,11.868L50,121.132C50,122.163 50.837,123 51.868,123L58.132,123C59.163,123 60,122.163 60,121.132L60,11.868Z",
    style: {
      fill: "rgb(197,207,214)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg2",
    serifId: "Leg",
    d: "M111,11.868C111,10.837 110.163,10 109.132,10L102.868,10C101.837,10 101,10.837 101,11.868L101,121.132C101,122.163 101.837,123 102.868,123L109.132,123C110.163,123 111,122.163 111,121.132L111,11.868Z",
    style: {
      fill: "rgb(197,207,214)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Head-Front-Wavy",
    serifId: "Head/Front/Wavy",
    transform: "matrix(-1,0,0,1,419.199,375.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "matrix(1,0,0,1,54,31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.262,34.49C3.654,29.081 0.536,22.453 1.057,15.025C2.558,-6.375 32.349,-1.667 38.143,9.134C43.938,19.935 43.25,47.333 35.76,49.263C32.774,50.033 26.411,48.147 19.935,44.244L24,73L0,73L8.262,34.49Z",
    style: {
      fill: "rgb(178,139,103)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    d: "M94.409,44.984C94.171,43.584 93.59,42.029 93.122,40.704C92.517,38.997 91.602,37.457 90.596,36.006C88.701,33.274 86.428,30.807 83.918,28.76C79.333,25.02 73.497,22.863 67.757,23.564C64.86,23.917 62.047,25.023 59.653,26.862C57.489,28.525 55.409,30.972 52.608,31.147C49.56,31.339 46.766,28.648 44.322,26.987C41.566,25.114 38.634,23.749 35.413,23.219C30.017,22.33 24.948,24.153 21.229,28.58C17.272,33.292 14.396,40.2 16.994,46.442C17.477,47.603 18.099,48.581 18.991,49.392C19.809,50.135 21.058,50.926 21.39,52.114C21.742,53.377 20.69,55.006 20.281,56.145C19.697,57.778 19.217,59.491 19.388,61.266C19.668,64.18 21.499,66.961 23.433,68.876C25.4,70.825 27.822,71.943 30.409,72.458C32.136,72.802 33.901,72.992 35.657,72.863C36.528,72.799 37.297,72.557 38.141,72.364C38.962,72.177 39.421,72.395 40.118,72.845C43.354,74.937 46.833,75.747 50.57,75.436C53.724,75.173 57.358,74.409 59.931,72.248C62.788,69.848 62.731,66.539 62.059,63.004C62.771,63.357 64.742,63.575 63.564,62.168C63.098,61.611 62.216,61.384 61.618,61.056C60.921,60.675 60.213,60.181 59.672,59.559C57.487,57.045 59.694,51.93 62.44,51.087C66.521,49.835 67.434,55.605 70.347,57.098C72.022,57.956 73.774,56.783 75.029,55.586C76.71,53.981 77.855,51.855 78.844,49.692C79.659,47.91 80.417,46.104 81.248,44.331C81.635,43.503 82.978,41.163 82.304,40.227C85.226,39.644 88.482,40.859 90.999,42.452C92.039,43.11 92.832,43.836 93.387,44.998C93.506,45.248 93.765,45.988 94.09,46.018C94.695,46.075 94.469,45.335 94.409,44.984",
    style: {
      fill: "rgb(25,24,71)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bottom-Standing-Skinny-Jeans",
    serifId: "Bottom/Standing/Skinny-Jeans",
    transform: "matrix(-1,0,0,1,507.745,570.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Leg3",
    serifId: "Leg",
    d: "M128,0L164.255,127.227L190.707,221L210,221L181.891,0L128,0Z",
    style: {
      fill: "rgb(25,24,71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg4",
    serifId: "Leg",
    d: "M118.304,0C117.466,65.574 114.606,101.34 113.726,107.298C112.845,113.256 99.532,151.156 73.786,221L93.773,221C126.549,153.997 144.846,116.096 148.662,107.298C152.479,98.5 164.259,62.734 182,0L118.304,0Z",
    style: {
      fill: "rgb(47,54,118)"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accessories-Shoe-Flat-Pointy",
    serifId: "Accessories/Shoe/Flat-Pointy"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Accessories-Shoe-Flat-Pointy1",
    serifId: "Accessories/Shoe/Flat-Pointy"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Body-Long-Sleeve",
    serifId: "Body/Long-Sleeve",
    transform: "matrix(-1,0,0,1,484.326,463.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    d: "M192,65.311L231.483,59.925C239.381,55.532 246.647,52.558 253.281,51.003C255.147,50.948 258.117,51.627 253.693,55.315C249.269,59.003 244.78,63.083 245.569,65.051C246.357,67.02 250.471,66.287 251.153,69.315C251.607,71.333 244.93,71.661 231.121,70.299L199.084,83L192,65.311ZM67.97,74.45L89.867,74.532C65.856,128.566 53.336,156.857 52.308,159.406C49.994,165.14 54.891,173.874 56.985,178.567C50.165,181.619 50.891,170.317 42.288,174.319C34.435,177.973 28.462,184.592 19.389,178.994C18.274,178.306 17.051,175.715 20.005,173.69C27.362,168.645 37.965,159.815 39.398,156.908C41.352,152.945 50.876,125.459 67.97,74.45Z",
    style: {
      fill: "rgb(153,118,89)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clothes-Back",
    transform: "matrix(0.996195,0.0871557,-0.0871557,0.996195,5.78843,-15.3939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.474,9.669L140.653,9.313C148.189,47.001 173.204,69.034 223.79,56.408L234.893,104.819C187.489,115.21 143.761,99.694 130.596,48.475C127.188,35.216 124.201,21.368 123.474,9.669Z",
    style: {
      fill: "rgb(175,185,197)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Clothes",
    d: "M119.491,0.016L145.468,5.965C145.468,50.644 159.7,79.15 167,112L96.844,112C95.855,123.351 95.248,135.018 94.932,147L42.402,147C54.305,83.664 79.43,34.664 117.776,0L119.477,0L119.491,0.016Z",
    style: {
      fill: "rgb(197,207,214)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shade1",
    serifId: "Shade",
    d: "M107.912,48.259C106.104,76.101 107.168,97.347 111.102,112L96.844,112C98.801,89.514 102.256,68.267 107.912,48.259L107.912,48.259Z",
    style: {
      fillOpacity: 0.1
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplashNwn);
export default __webpack_public_path__ + "static/media/SplashNWN.b2ec6141d9e516fe4d92ada5f45fc0cf.svg";
export { ForwardRef as ReactComponent };